export const breakpoints = {
    mobileXS: '320px',
    mobileS: '375px',
    mobileM: '425px',
    mobileL: '432px',
    tablet: '768px',
    desktop: '1024px'
};
